<div class="activity-group-container">
    <div class="content-wrapper">
        <div class="form-container">
            <h3 class="page-title">Éditer un regroupement d'activités</h3>
            
            <form 
                [formGroup]="entityForm"
                (ngSubmit)="onSubmitActivity()"
                class="activity-form"
            >
                <!-- Section des activités -->
                <div class="activities-section">
                    <div class="activities-card">
                        <div class="activities-header">
                            <h4 class="section-title">Activités associées</h4>
                            <button
                                type="button"
                                class="btn-add-activity"
                                (click)="addActivity()"
                            >
                                <mat-icon>add</mat-icon>
                                <span>Ajouter une activité</span>
                            </button>
                        </div>
                        
                        <!-- Liste des activités -->
                        <div 
                            class="activities-list" 
                            formArrayName="activitesSelectionnees"
                        >
                            @for (control of activitesFormArray.controls; track $index) {
                                <div class="activity-row">
                                    <app-select
                                        [formControlName]="$index"
                                        [options]="getAvailableActivities($index)"
                                        class="activity-select"
                                    />
                                    <button
                                        type="button"
                                        (click)="removeActivity($index)"
                                        class="btn-delete"
                                        [disabled]="activitesFormArray.length <= 1"
                                        [attr.aria-label]="'Supprimer l\'activité ' + ($index + 1)"
                                    >
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            }
                        </div>
                    </div>

                    <!-- Informations complémentaires -->
                    @if (activitesFormArray.length > 1 && activeStepId) {
                        <div formGroupName="complementaryInfo" class="complementary-info-section">
                            <h4 class="section-title">Informations complémentaires</h4>
                            
                            <!-- Navigation par onglets -->
                            <nav class="tabs-navigation">
                                @for (step of steps; track step.id) {
                                    <a
                                        [routerLink]="[]"
                                        [queryParams]="{ step: step.id }"
                                        [class.active]="activeStepId === step.id"
                                        class="tab-link"
                                    >
                                        {{ step.label }}
                                    </a>
                                }
                            </nav>

                            <!-- Contenu des étapes -->
                            <div class="steps-content">
                                @if (activeStepId === 'generales') {
                                    <div class="step-content">
                                        <app-steponeactivities
                                            [generalesData]="activity.generales"
                                            (generalesChanges)="updateActivity($event, 'generales')"
                                            (typeActivityChanged)="handleTypeActivityChange($event)"
                                        />
                                    </div>
                                }
                                @if (activeStepId === 'activites') {
                                    <div class="step-content">
                                        <app-steptwoactivities
                                            [activitiesData]="activity.activites"
                                            (activitiesChanges)="updateActivity($event, 'activites')"
                                            (pmpModeSelected)="handlePmpModeChange($event)"
                                        />
                                    </div>
                                }
                                @if (activeStepId === 'budgets') {
                                    <div class="step-content">
                                        <app-stepthreeactivities
                                            [budgetsData]="activity.budgets"
                                            (budgetsChanges)="updateActivity($event, 'budgets')"
                                            (submitActivity)="onSubmitActivity()"
                                        />
                                    </div>
                                }
                                @if (activeStepId === 'stepfour' && showPmpStep) {
                                    <div class="step-content">
                                        <app-stepfouractivities
                                            [stepfourData]="activity.stepfour"
                                            (stepfourChanges)="updateActivity($event, 'stepfour')"
                                        />
                                    </div>
                                }
                                @if (activeStepId === 'recap') {
                                    <div class="step-content">
                                        <app-recapactivities 
                                            [activityData]="activity"
                                            (submitFinalActivity)="handleFinalSubmit()"
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>

                <!-- Bouton de soumission -->
                <button
                    type="submit"
                    class="btn-submit"
                    [disabled]="isLoading"
                >
                    <span [class.hidden]="isLoading">Soumettre</span>
                    @if (isLoading) {
                        <div class="loader-wrapper">
                            <app-loader></app-loader>
                        </div>
                    }
                </button>
            </form>
        </div>
    </div>
</div>